import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

const Projects = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Projects component');
    }

    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetch('/data/projects.json')
            .then(response => response.json())
            .then(data => {
                // Sort by ID descending and take top 2
                const sortedData = [...data].sort((a, b) => b.id - a.id).slice(0, 2);
                setProjects(sortedData);
            })
            .catch(error => console.error('Error fetching projects data:', error));
    }, []);

    const scrollToSkills = () => {
        const skillsSection = document.getElementById('skills');
        if (skillsSection) {
            skillsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="mainArea transition-effect" id="projects">
            <div className="projects transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/misc/gh.png"
                        alt="Projects Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Projects
                            </div>

                            <img
                                src="/images/siteElements/scroll-both.png"
                                alt="Scroll Up Indicator"
                                className="projScrollUp"
                                onClick={scrollToSkills}
                            />
                        </div>
                        <div className="rightContent">
                            <div className="projectsList">
                                {projects.map((project) => (
                                    <div className="projectCard" key={project.id}>
                                        <h3 className="projectTitle">{project.title}</h3>

                                        <div className="projectTechWrapper">
                                            <div className="projectTechStack">
                                                {project.technologies.map((tech, index) => (
                                                    <span className="projectTech" key={index}>{tech}</span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="projectDescription">
                                            {project.description}
                                        </div>

                                        <div className="projectLinks">
                                            {project.github && (
                                                <a href={project.github} target="_blank" rel="noopener noreferrer" className="projectLink">
                                                    <i className="fa-brands fa-github"></i> GitHub
                                                </a>
                                            )}
                                            {(project.demo || project.live) && (
                                                <a href={project.demo || project.live} target="_blank" rel="noopener noreferrer" className="projectLink">
                                                    <i className="fa-solid fa-arrow-up-right-from-square"></i> Live Demo
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="projViewMoreContainer">
                                <Link to="/projects" className="projViewMoreLink">
                                    View More <i className="fa-solid fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Projects Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Projects;